export default "<n2pc-loader></n2pc-loader>\n"